import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatService } from './chat.service';
import { ThreadsComponent } from './components/threads/threads.component';
import {
  NbChatModule,
  NbListModule,
  NbUserModule,
  NbButtonModule,
  NbIconModule,
  NbBadgeModule,
  NbSpinnerModule,
  NbInputModule,
  NbFormFieldModule,
  NbCardModule,
} from '@nebular/theme';
import { ChatWindowComponent } from './components/chat-window/chat-window.component';
import { ChatAppComponent } from './components/chat-app/chat-app.component';
import { AudioRecorderComponent } from './components/audio-recorder/audio-recorder.component';
import { MessageComponent } from './components/message/message.component';
import { FileMessageViewerComponent } from './components/file-message-viewer/file-message-viewer.component';

@NgModule({
  imports: [
    CommonModule,
    NbFormFieldModule,
    NbUserModule,
    NbListModule,
    NbButtonModule,
    NbIconModule,
    NbChatModule,
    NbBadgeModule,
    NbSpinnerModule,
    NbInputModule,
    NbCardModule,
    NbUserModule,
  ],
  providers: [ChatService],
  declarations: [
    ThreadsComponent,
    ChatWindowComponent,
    ChatAppComponent,
    AudioRecorderComponent,
    MessageComponent,
    FileMessageViewerComponent,
  ],
  exports: [ThreadsComponent, ChatWindowComponent, ChatAppComponent],
})
export class ChatModule {}